import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter subscription logic will be implemented with Mailchimp
    console.log('Newsletter subscription:', email);
    setIsSubscribed(true);
    setEmail('');
    setTimeout(() => setIsSubscribed(false), 3000);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
                <i className="ri-compass-3-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                  SeninYolun
                </h3>
                <p className="text-sm text-teal-400">Esin Arifoğlu</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              ICF akredite koçu Esin Arifoğlu ile öğrenci, ebeveyn ve kariyer koçluğu hizmetleri. 
              Yolun netleşsin, hedeflerine ulaş.
            </p>
            
            {/* Newsletter */}
            <div className="mb-6">
              <h4 className="font-semibold mb-3">Koçluk Rehberleri İçin E-posta Listesine Katıl</h4>
              {isSubscribed ? (
                <div className="bg-teal-600 text-white px-4 py-2 rounded-lg">
                  ✓ Başarıyla abone oldunuz!
                </div>
              ) : (
                <form onSubmit={handleNewsletterSubmit} className="flex">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-posta adresiniz"
                    className="flex-1 px-4 py-2 rounded-l-lg text-gray-900 focus:outline-none"
                    required
                  />
                  <Button type="submit" className="rounded-l-none">
                    Abone Ol
                  </Button>
                </form>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li><Link to="/hakkimda" className="text-gray-300 hover:text-teal-400">Hakkımda</Link></li>
              <li><Link to="/hizmetlerim" className="text-gray-300 hover:text-teal-400">Hizmetlerim</Link></li>
              <li><Link to="/video-podcast" className="text-gray-300 hover:text-teal-400">Video & Podcast</Link></li>
              <li><Link to="/egitimler" className="text-gray-300 hover:text-teal-400">Eğitimler</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-teal-400">Blog</Link></li>
              <li><Link to="/iletisim" className="text-gray-300 hover:text-teal-400">İletişim</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">İletişim</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-teal-400"></i>
                <span className="text-gray-300">info@seninyolun.net</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-whatsapp-line text-teal-400"></i>
                <span className="text-gray-300">WhatsApp İletişim</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-building-line text-teal-400"></i>
                <span className="text-gray-300">Üç Boyut Eğitim Danışmanlık</span>
              </div>
            </div>
            
            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-300 hover:text-teal-400">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-teal-400">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-teal-400">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 SeninYolun. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/gizlilik" className="text-gray-400 hover:text-teal-400 text-sm">
              Gizlilik Politikası
            </Link>
            <Link to="/kullanim-sartlari" className="text-gray-400 hover:text-teal-400 text-sm">
              Kullanım Şartları
            </Link>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 text-sm">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;